"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsIphoneX = checkIsIphoneX;
exports.checkPayTencentDocs = checkPayTencentDocs;
exports.closest = closest;
exports.getBkn = getBkn;
exports.getCookie = getCookie;
exports.getIOSVersion = getIOSVersion;
exports.getLoginType = getLoginType;
exports.getXsrf = getXsrf;
exports.inWhichSplitView = inWhichSplitView;
exports.isIphoneX = void 0;
exports.isPortrait = isPortrait;
function checkPayTencentDocs() {
  var version = /TencentDocs\/[\d\.]+/.exec(window.navigator.userAgent);
  var docVersion = version && version[0].split('/') || false;
  var i = 0;
  var l = 0;
  var r, len;
  if (docVersion) {
    var a = String(docVersion[1]).split('.');
    var b = '1.8.1'.split('.');
    for (i = 0, len = Math.max(a.length, b.length); i < len; i++) {
      l = isFinite(Number(a[i])) && Number(a[i]) || 0;
      r = isFinite(Number(b[i])) && Number(b[i]) || 0;
      if (l < r) {
        return -1;
      } else if (l > r) {
        return 1;
      }
    }
  }
  return 0;
}
function checkIsIphoneX() {
  // iPhone X、iPhone XS
  var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && (window.screen.width === 812 && window.screen.height === 375 || window.screen.width === 375 && window.screen.height === 812);
  // iPhone XS Max
  var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && (window.screen.width === 414 && window.screen.height === 896 || window.screen.width === 896 && window.screen.height === 414);
  // iPhone XR
  var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && (window.screen.width === 414 && window.screen.height === 896 || window.screen.width === 896 && window.screen.height === 414);
  return isIPhoneX || isIPhoneXSMax || isIPhoneXR;
}
/* eslint-enable complexity */

var isIphoneX = checkIsIphoneX();

/**
 * 判断是否竖屏
 */
exports.isIphoneX = isIphoneX;
function isPortrait() {
  if (typeof window.orientation == 'number') {
    return window.orientation / 90 % 2 == 0;
  }
  try {
    // @ts-ignore
    var angle = window.screen.orientation.angle;
    if (typeof angle == 'number') {
      return angle / 90 % 2 == 0;
    }
  } catch (err) {}
  return true;
}

/**
 * 判断 iPad 分屏模式
 * 用大致的比例区间来判断即可
 * [1] 不在分屏模式
 * [0.5] 处于二分之一屏
 * [0.33] 处在三分之一屏
 * [0.66] 处在三分之二屏
 */
function inWhichSplitView() {
  var screenWidth = isPortrait() ? window.screen.width : window.screen.height;
  var innerWidth = window.innerWidth;
  var rate = innerWidth / screenWidth;
  if (rate < 0.4) {
    return 0.33;
  } else if (rate >= 0.4 && rate < 0.6) {
    return 0.5;
  } else if (rate >= 0.6 && rate < 0.9) {
    return 0.66;
  } else {
    return 1;
  }
}

/**
 * 检查指定元素是否是指定selector的子元素
 */
function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector ||
  //@ts-ignore
  el.mozMatchesSelector ||
  //@ts-ignore
  el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    } else {
      el = el.parentElement;
    }
  }
  return null;
}
function getXsrf() {
  return getCookie('TOK') || '';
}
function getCookie(key) {
  var m = document.cookie.match(new RegExp('(^| )' + key + '=([^;]*)(;|$)'));
  return !m ? '' : decodeURIComponent(m[2]);
}
function getBkn() {
  var t = getCookie('skey'),
    n = 5381;
  if (!t) {
    return;
  }
  for (var e = 0, o = t.length; o > e; ++e) {
    n += (n << 5) + t.charAt(e).charCodeAt();
  }
  return 2147483647 & n;
}
function getLoginType() {
  var utype = getCookie('utype');
  if (utype === 'qq') {
    return 1;
  } else if (utype === 'wx') {
    return 2;
  } else if (utype === 'ww') {
    return 3;
  }
  return 0;
}
function getIOSVersion() {
  var ua = navigator.userAgent.toLowerCase();
  var version = null;
  if (ua.indexOf('like mac os x') > 0) {
    var reg = /os [\d._]+/gi;
    var v_info = ua.match(reg);
    version = String(v_info).replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); //得到版本号9.3.2或者9.0
    version = parseInt(version.split('.')[0], 10); // 得到版本号第一位
  }

  return version;
}